<template lang="html">
  <div class="consultantList-layout" v-if="citycode">
    <banner :posters="banner" :citycode="citycode">
      <cityTrigger :pagelocating="pagelocating" :cityname="cityname" />
    </banner>
    <!-- 育儿顾问咨询  -->
    <div class="home-consultant" :class="{ noContent: list.length == 0 }">
      <h3>
        <i></i>
      </h3>
      <loadData
        viewName="consultantListWorkers"
        :fetchData="list"
        :fetchMethod="getWorker"
        :controlPage="changePage"
        :page="pageIndex"
        :pageSize="pageSize"
        :firstFetch="firstFetch"
        :hasErr="hasErr"
        :otherParams="{ errText: '您的附近暂无育儿顾问' }"
      />
    </div>
    <!--不要删除,兼容iphonex -->
    <div class="menu_wkBox_back_box"></div>
  </div>
</template>

<script>
import banner from '@/components/index/banner'
import cityTrigger from '@/components/consultantList/cityTrigger'
import { mapState, mapMutations } from 'vuex'
import loadData from '@/components/loadMore'

import {
  getLocation,
  getCityCode,
  getCekidCityCode,
  getAPPLatAndLng
} from '@/plugins/location'

export default {
  data() {
    return {
      citycode: '',
      cityname: '',
      homeSettings: {},
      pagelocating: true,
      pageIndex: 1,
      pageSize: 10,
      list: [],
      firstFetch: true,
      hasErr: false
    }
  },
  async created() {
    const json = await this.$store.dispatch('getIndexPageSettings')
    const city = (this.$$cookie('city_service') || '').split('_')[0]
    if (city) {
      this.citycode = city
    } else {
      this.citycode = this.$$cookie('citycode') || ''
    }
    if (this.$$isHZWApp()) {
      const { lat, lng } = getAPPLatAndLng()
      if (!this.citycode) {
        this.citycode = '320100'
      }
      this.lat = lat
      this.lng = lng
    } else {
      const { citycode, cityname, lat, lng } = await getLocation()
      if (!this.citycode) {
        this.citycode = citycode
        this.cityname = cityname
      }
      this.lat = lat
      this.lng = lng
    }

    const res = await this.$store.dispatch('getNameById', {
      addressId: this.citycode
    })
    if (res) {
      this.citycode = res.ID
      this.cityname = res.NAME.replace('市', '')
    }
    this.$$cookie.set('groupcity', this.citycode)
    this.pagelocating = false
    this.homeSettings = JSON.parse(this.buildLink(JSON.stringify(json)))
    this.$$loading(false)
    this.$$title(this.homeSettings.pageTitle)
    //this.$$share(this.homeSettings.shareInfo || {})
    this.getWorker()
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
  },
  computed: {
    banner() {
      return []
    }
  },
  methods: {
    buildLink(link) {
      return decodeURIComponent(link)
        .replace(/\[cityname\]/g, this.cityname || '')
        .replace(/\[citycode\]/g, this.citycode || '')
    },
    changeCityToPrivinceCityCode() {
      return getCityCode(this.citycode)
    },

    share(city) {
      this.$$share({
        title: this.homeSettings.shareInfo.title,
        desc: this.homeSettings.shareInfo.desc,
        imgUrl: this.homeSettings.shareInfo.image,
        link: `${this.$$hostname('life')}/v/home`
      })
    },
    async getWorker() {
      try {
        if (this.pageIndex === 1) {
          this.list.length = 0
          this.list = []
        }
        // console.log(this.searchCityName)
        const workerlist = await this.$store.dispatch('getAllWorkers', {
          cityId: this.citycode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          userTypes: [1]
        })
        if (workerlist.length > 0) {
          this.list.push(...(workerlist || []))
        }
        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        // this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    }
  },
  components: {
    banner,
    cityTrigger,
    loadData
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.home-consultant {
  width: rem(702px);
  margin: 0 auto;
  margin-top: rem(-90px);
  position: relative;

  & > h3 {
    display: block;
    height: rem(90px);
    background: url('~@/assets/images/bg-consultantList@3x.png') no-repeat top
      center;
    background-size: 100% auto;
    position: relative;
    display: flex;
    align-items: flex-end;
    i {
      width: 100%;
      display: block;
      background: url('~@/assets/images/bg-consultantListtittle@3x.png')
        no-repeat bottom center;
      background-size: rem(280px) auto;
      height: rem(48px);
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/css/mixin';
.consultantList-layout {
  padding-bottom: rem(48px);
}
.consultantList-layout .banner-home-ui.noBanner {
  background-image: url('~@/assets/images/banner_consultantList.png');
  height: rem(410px);
}
.consultantList-layout .home-consultant.noContent .data-container {
  background-color: #fff;
  margin-top: -1px;
  border-bottom-left-radius: rem(16px);
  border-bottom-right-radius: rem(16px);
  min-height: calc(100vh - 4.6rem);
}
.consultantList-layout
  .home-consultant.noContent
  .data-container
  .data-null.inside {
  padding-top: 1.6rem !important;
}
</style>
